import HeroSection from "./components/HeroSection";
import ComparisonSection from "./components/ComparisonSection";
import AdvantagesSection from "./components/AdvantagesSection";
import ProcessFlowSection from "./components/ProcessFlowSection";
import ScenariosSection from "./components/ScenariosSection";
import FinalCtaSection from "./components/FinalCtaSection";
import SEOMeta from "@/components/feature/SEOMeta";

const siteUrl = (typeof import.meta !== "undefined" && import.meta.env?.VITE_SITE_URL) || "https://chronosspace.com";

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "Article",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": `${siteUrl}/technology`
  },
  "headline": "預製工法 vs 傳統工法｜速築美宅家 Chronos Space",
  "description": "從工期、品質、耐震、節能到碳排放，全方位比較預製工法與傳統工法的差異。了解為何 Chronos Space 選擇預製鋼構工法。",
  "author": {
    "@type": "Organization",
    "name": "速築美宅家 Chronos Space"
  },
  "publisher": {
    "@type": "Organization",
    "name": "速築美宅家 Chronos Space",
    "url": siteUrl
  },
  "datePublished": "2025-01-01",
  "dateModified": "2025-03-15",
  "about": {
    "@type": "Thing",
    "name": "預製工法"
  }
};

export default function TechnologyPage() {
  return (
    <main>
      <SEOMeta
        title="預製工法優勢｜縮短 50% 施工期"
        description="從工期、品質、耐震、節能到碳排放，全方位比較預製鋼構工法與傳統工法的差異。了解為何 Chronos Space 選擇預製鋼構工法。"
        keywords="預製工法,鋼構住宅,預鑄工法,鋼結構,自地自建工法,建築工法比較"
        canonicalPath="/technology"
        ogType="article"
        jsonLd={jsonLd}
      />
      <HeroSection />
      <ComparisonSection />
      <AdvantagesSection />
      <ProcessFlowSection />
      <ScenariosSection />
      <FinalCtaSection />
    </main>
  );
}